import { RotaCheckbox } from "@teamrota/rota-design";
import React, { useState } from "react";
import PredictedShiftPopup from "./PredictedShiftPopup";

const ShiftPredicted = ({ handleShiftUpdate, shift }) => {
  const [isShowPopup, setIsShowPopup] = useState(false);

  const handlePopupSave = () => {
    setIsShowPopup(false);
  };

  const handlePopupClose = () => {
    handleShiftUpdate({ isPredicted: false });
    setIsShowPopup(false);
  };

  const handleCheckboxToggle = () => {
    handleShiftUpdate({
      isPredicted: !shift.isPredicted
    });

    setIsShowPopup(!shift.isPredicted);
  };

  return (
    <div>
      <RotaCheckbox
        label={"This is a Predicted shift"}
        isChecked={shift.isPredicted}
        onClick={handleCheckboxToggle}
      />
      {isShowPopup && (
        <PredictedShiftPopup
          onClose={handlePopupClose}
          onSave={handlePopupSave}
        />
      )}
    </div>
  );
};

export default ShiftPredicted;
